import { ElementType, useId } from "react";
import { Box } from "@mui/material";

import laptopBlank from "./assets/laptop-blank.png";

/** Градиент значка — снят с треугольника утверждённой иллюстрации 404. */
const GRADIENT_TOP = "#67C275";
const GRADIENT_BOTTOM = "#C1E0C6";

/**
 * Наклон плоскости экрана: боковые края экрана вертикальны, верхний и нижний
 * опускаются вправо на 0,142 — это сдвиг по Y на 8°, без перспективы.
 * Под тем же углом нарисован треугольник 404.
 */
const SCREEN_SKEW_Y = "8deg";

interface InfoPageIllustrationProps {
  /** Залитая иконка MUI, которая встаёт на экран ноутбука. */
  icon: ElementType;
  alt?: string;
}

/**
 * Иллюстрация 404 с пустым экраном и значком состояния поверх. Основа — та же
 * картинка из Figma, поэтому серия страниц выглядит одинаково, а новое состояние
 * добавляется выбором иконки. Позиция и размер значка повторяют треугольник 404.
 */
export const InfoPageIllustration = ({
  icon: Icon,
  alt = "",
}: InfoPageIllustrationProps): JSX.Element => {
  const gradientId = `info-page-gradient-${useId().replace(/:/g, "")}`;

  return (
    <Box
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      sx={{ maxWidth: "100%", position: "relative", width: 384 }}
    >
      <Box
        component="img"
        src={laptopBlank}
        alt=""
        sx={{ display: "block", height: "auto", width: "100%" }}
      />
      <svg width={0} height={0} style={{ position: "absolute" }} aria-hidden={true}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor={GRADIENT_TOP} />
            <stop offset="1" stopColor={GRADIENT_BOTTOM} />
          </linearGradient>
        </defs>
      </svg>
      <Icon
        sx={{
          fill: `url(#${gradientId})`,
          height: "26%",
          left: "57.8%",
          position: "absolute",
          top: "42.1%",
          transform: `translate(-50%, -50%) skewY(${SCREEN_SKEW_Y})`,
          width: "26%",
        }}
      />
    </Box>
  );
};
